import { Logger } from '@/utils/logger';
import AuthService from '@montugroup/circuit-shared/services/authentication.service';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

const logger = new Logger('sidebar/Logout');

const LogoutMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: `${theme.spacing(4)} 0 ${theme.spacing(4)} ${theme.spacing(7)}`,
  fontWeight: theme.typography.fontWeightMedium,
  gap: theme.spacing(4),
  borderRadius: 0,
  justifyContent: 'flex-start',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  marginTop: 'auto',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

function Logout({ toggleText = true }: { toggleText?: boolean }) {
  return (
    <LogoutMenuItem
      onClick={() => {
        logger.info('LogoutMenuItem onClick');
        AuthService.logout();
      }}
    >
      <LogoutIcon />
      {toggleText && 'Logout'}
    </LogoutMenuItem>
  );
}

export default Logout;
